module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./node_modules/stream-browserify/node_modules/readable-stream/transform.js
// module id = I6RR
// module chunks = 0